const CompletionStatus = ({ playlistCount, skippedPlaylistCount }) => {
  const total = (playlistCount || 0) + (skippedPlaylistCount || 0);

  if (total === 0 && !playlistCount) return null;

  const skippedTitle =
    total === 1
      ? 'Playlist already converted'
      : playlistCount > 0
        ? `${skippedPlaylistCount} of ${total} playlists already converted`
        : 'All playlists already converted';

  return (
    <small className="text-success d-flex align-items-center flex-shrink-0">
      <i
        aria-hidden="true"
        style={{ fontSize: '0.75rem' }}
        className="fas fa-check-circle me-1"
      ></i>
      <span>
        {total} {total === 1 ? 'playlist' : 'playlists'}
        {skippedPlaylistCount > 0 && (
          <span title={skippedTitle}>
            {' '}
            ({playlistCount > 0 ? `${skippedPlaylistCount} skipped` : total === 1 ? 'skipped' : 'all skipped'})
          </span>
        )}
      </span>
    </small>
  );
};

export default CompletionStatus;
